// Module
var code = "<template> <compose containerless if.bind=\"showNavigation\" view=\"./navigation-top.html\"></compose> <compose containerless if.bind=\"showNavigation\" view=\"./navigation-menu.html\"></compose> <compose containerless if.bind=\"showNavigation\" view=\"./navigation-view-menu.html\"></compose> </template> ";
// Exports
export default code;